module.exports = {
  dish1: {
    name: "Caribbean 1",
    description: "Insert Caribbean 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Caribbean 2",
    description: "Insert Caribbean 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Caribbean 3",
    description: "Insert Caribbean 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Caribbean 4",
    description: "Insert Caribbean 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Caribbean 5",
    description: "Insert Caribbean 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Caribbean 6",
    description: "Insert Caribbean 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Caribbean 7",
    description: "Insert Caribbean 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Caribbean 8",
    price: 4400,
    description: "Insert Caribbean 8 description",
    status: "available"
  },
  dish9: {
    name: "Caribbean 9",
    price: 3300,
    description: "Insert Caribbean 9 description",
    status: "available"
  },
  dish10: {
    name: "Caribbean 10",
    price: 3900,
    description: "Insert Caribbean 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/JamaicaMeCrazy.js